import _ from 'lodash';

export default class RoamingRCC {
  constructor(data) {
    const defaults = {
      voice: 0,
      data: 0,
      sms: 0,
      additional: 0,
    };
    data = _.merge(defaults, data);
    this.voice = data.voice;
    this.data = data.data;
    this.sms = data.sms;
    this.additional = data.additional;
  }

  get total() {
    return this.voice + this.data + this.sms + this.additional;
  }
}
